import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { Helmet } from "react-helmet"

import HowItWorks from 'components/_special/HowItWorks'
import KitScience from 'components/_special/KitScience'
import ProductTextLineBanner from 'components/_special/ProductTextLineBanner'
import FaqBlock from 'components/FaqBlock'
import StoriesSlider from 'components/StoriesSlider'
import WillLearnDna from 'components/WillLearnDna'
import { JP, RU, UK, BE, NL, IE } from 'constants/countries'
import { GOODS_TYPES } from 'constants/sales'
import { DEVELOPMENT } from 'constants/environments'
import { cityAdsDNAPage } from 'constants/cityAdsScripts'
import CartSaleWideContainer from 'containers/CartSaleWideContainer'
import DistributionBannerContainer from 'containers/DistributionBannerContainer'
import { LocalizationContext } from 'contexts/Localization'
import { ResizeContext } from 'contexts/Resize'
import { dnaHowItWorks, dnaResults } from 'routes'
import { LastBlock } from 'styles/components/layout'
import useCurrentPromoEvent from 'hooks/useCurrentPromoEvent'

import HeaderPad from './components/HeaderPad'
import Intro from './components/Intro'
import DAboutDefinition from './components/DAboutDefinition'
import DAboutFirstBlock from './components/DAboutFirstBlock'
import DAboutOrderTest from './components/DAboutOrderTest'
import {
  FaqWrapper,
  SecondBlock,
  ThirdBlock,
  TrustpilotReviewsStyled,
} from './styles'

const DnaAbout = function({ texts, publications, locale, stories }) {
  const { mobile, tablet } = React.useContext(ResizeContext)
  const { paths } = React.useContext(LocalizationContext)
  const secondBlock = React.useRef()

  //костыль для серверного рендера, блоки которые зависят от акций должны полностью ререндериться
  const [IntroRenderSource, setIntroRenderSource] = useState('server')
  useEffect(() => {
    setIntroRenderSource('client')
  }, [])

  //для акций UK странички аналогичны RU
  const event = useCurrentPromoEvent(locale)

  return (
    <>
      {(process.env.NODE_ENV !== DEVELOPMENT && locale === RU)
        && <Helmet><script id='xcntmyAsync' type='text/javascript'>{cityAdsDNAPage}</script></Helmet>
      }
      {locale === RU ? (
        <>
          <HeaderPad />
          <Intro
            key={`Intro-DNA-${IntroRenderSource}-render`}
            translations={texts.first}
            goodsType={GOODS_TYPES.dna}
          />
        </>
      ) : (event && event.countries.includes(locale) && event.withStyledProductPages )
        ? (
        <div>
          <HeaderPad />
          <Intro
            translations={texts.first}
            goodsType={GOODS_TYPES.dna}
          />
        </div>)
        : (
        <DAboutFirstBlock
          key={`FirstBlock-DNA-${IntroRenderSource}-render`}
          data={texts.first}
          secondBlockRef={secondBlock}
        />
      )}

      <ProductTextLineBanner />

      {[UK, BE, NL, IE].includes(locale) && (
        <TrustpilotReviewsStyled/>
      )}
      <SecondBlock ref={secondBlock}>
        <WillLearnDna
          data={texts.traits}
          mobile={mobile}
          results={dnaResults}
          bgClassName={'bg--blue-dark'}
        />
      </SecondBlock>

      {locale !== RU && (
        <ThirdBlock>
          <DAboutDefinition data={texts.dna_definition} />
        </ThirdBlock>
      )}
      <HowItWorks
        data={texts.how_works}
        coverUrl={`${paths.cdn_global}/common_hiw/hiw/how_the_test_works`}
        link={dnaHowItWorks}
      />

      {locale === RU && (
        <DAboutOrderTest
          data={texts.order_test}
          path={`${paths.cdn_global}/boxes`}
        />
      )}

      <KitScience data={texts.science} mobile={mobile} tablet={tablet} />
      {locale !== JP && stories && stories.list && (
        <StoriesSlider
          slides={stories.list}
          isMobile={mobile}
          path={paths.cdn_global}
          locale={locale}
        />
      )}
      {/* TODO: Временно скрытый блок с публикациями */}
      {/* <Publications
        isMobile={mobile}
        list={(publications && publications.list) || []}
        logos={`${paths.shared}/publications_logo`}
      /> */}

      <FaqWrapper>
        <FaqBlock
          isMobile={mobile}
          items={texts.faq.list}
          title={texts.faq.title}
          locale={locale}
        />
      </FaqWrapper>

      <LastBlock>
        <CartSaleWideContainer productType={GOODS_TYPES.dna} />

        <DistributionBannerContainer />
      </LastBlock>
    </>
  )
}

DnaAbout.propTypes = {
  language: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  texts: PropTypes.object.isRequired,
  publications: PropTypes.object,
  stories: PropTypes.object,
}

export default DnaAbout
